export const environment = {
  production: true,
  hideNavbar: false,
  url: "https://exon-iam-be-dev.amitia-ai.com",
  allowedDomains: ["exon-iam-be-dev.amitia-ai.com"],
  iccAppUrl: "http://inkcapture-dev.amitia-ai.com/",
  restricted_functions_whitelist: ["jan.valenta@exon.cz"],
};
